(() => {
  const header = document.querySelector('#header-component[data-sticky-announcement]');
  if (!header) return;

  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;

  const section = bar.closest('.shopify-section') || bar;

  const setHeight = () => {
    document.body.style.setProperty('--announcement-bar-height', `${section.offsetHeight}px`);
  };

  setHeight();

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(setHeight).observe(section);
  }

  window.addEventListener('resize', setHeight, { passive: true });
})();
